import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=1360f38a&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=1360f38a&prod&lang=css"
import style1 from "./UserList.vue?vue&type=style&index=1&id=1360f38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360f38a",
  null
  
)

export default component.exports